<template>
    <AppModal v-if="$store.state.isMobile && showModal && !rejectedApp" @close="handleRejectApp" />
    <router-view />
</template>

<script>
import AppModal from '@/components/AppModal.vue';
import CookieConsent from '@/components/CookieConsent.vue';
export default {
    components: {
      CookieConsent,
      AppModal,
    },
    data() {
      return {
        showModal: false,
        rejectedApp: false,
        showPopupNewsletter: false,
      };
    },
    watch: {
      showModal(value) {
        if (this.rejectedApp) return;
        const appElement = document.getElementById('app');
        if (value) {
          appElement.style.overflow = 'hidden';
        } else {
          appElement.style.overflow = 'auto';
        }
      }
    },
    beforeMount() {
      if (localStorage.getItem("rejectedApp") === null) {
        localStorage.setItem("rejectedApp", false);
        this.rejectedApp = false;
      } else {
        this.rejectedApp = localStorage.getItem("rejectedApp") === 'true';
      }
    },
  
    created() {
      if (window.innerWidth <= 800) {
        this.$store.commit("SET_IS_MOBILE", true);
        this.showModal = true;
      } else {
        this.$store.commit("SET_IS_MOBILE", false);
      }
    },
    methods: {
      handleCookiesAccepted() {
        localStorage.setItem("acceptedCookies", true);
      },
      handleCookiesRejected() {
        localStorage.setItem("acceptedCookies", false);
        if (this.isToken) {
          Cookies.remove("Token");
          Cookies.remove("Userid");
          Cookies.remove("username");
          window.location.reload();
        }
      },
      handleRejectApp() {
        this.showModal = false;
        localStorage.setItem("rejectedApp", true);
        this.rejectedApp = true;
      },
      closeNewsletterPopup() {
        this.showPopupNewsletter = false;
      }
    },
}
</script>